import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#1F3D2B] py-4 px-3 text-center border-t-4 border-[#D4A843]" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <p className="font-black text-white mb-1 text-base uppercase tracking-widest" data-id="element-49">
          🌾 KIT COMPLETO GESTIÓN AGROPECUARIA
        </p>
        <p className="text-gray-400 font-bold text-xs mb-2 uppercase" data-id="element-50">
          © 2026 Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4 text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-51">
          <span className="cursor-pointer hover:text-[#D4A843] transition-colors" data-id="element-52">
            Términos y Condiciones
          </span>
          <span className="cursor-pointer hover:text-[#D4A843] transition-colors" data-id="element-53">
            Políticas de Privacidad
          </span>
        </div>
      </div>
    </footer>;
}